// src/components/shops/postTemplates/Seasonal.tsx
//
// A warm, festive card for seasonal moments — holiday hours, a winter drink, a
// summer release. A thin gold double-frame and a small centred motif do the
// seasonal work without leaning on any one holiday's colours, so the same card
// reads right in December and in July.

import { cachedUrl } from '../../../lib/storageUrl'
import SocialBrewBadge from '../SocialBrewBadge'
import { categoryLabel, type TemplateProps } from './types'

export default function Seasonal({
  title, body, photos, category, shopName, rating, ratingCount, scale = 1,
}: TemplateProps) {
  const px = (n: number) => `${n * scale}px`
  const label = categoryLabel(category) || 'Seasonal'
  const photo = photos[0]

  return (
    <div
      className="overflow-hidden"
      style={{ borderRadius: px(3), background: '#2a1c12', padding: px(6) }}
      data-shop={shopName}
    >
      <div
        style={{
          border: `${px(1.5)} solid #c99a53`,
          borderRadius: px(2),
          padding: px(5),
        }}
      >
        <div
          style={{
            border: `${px(0.75)} solid rgba(232,176,106,0.5)`,
            borderRadius: px(1.5),
            background: 'linear-gradient(180deg,#f7efe1,#efe3cf)',
            padding: `${px(18)} ${px(18)} ${px(16)}`,
          }}
        >
          <p
            style={{
              fontSize: px(8.5),
              letterSpacing: '0.32em',
              textTransform: 'uppercase',
              color: '#a4652a',
              fontWeight: 700,
              textAlign: 'center',
              marginBottom: px(10),
            }}
          >
            ❄ &nbsp;{label}&nbsp; ❄
          </p>

          {photo && (
            <div style={{ borderRadius: px(2), overflow: 'hidden', marginBottom: px(14), aspectRatio: '4 / 3' }}>
              <img src={cachedUrl(photo)} alt="" loading="lazy" className="w-full h-full object-cover" />
            </div>
          )}

          <h3
            className="font-display"
            style={{
              fontSize: px(25),
              lineHeight: 1.12,
              letterSpacing: '-0.015em',
              color: '#2a1c12',
              fontWeight: 700,
              margin: 0,
              textAlign: 'center',
              textWrap: 'balance',
            }}
          >
            {title}
          </h3>

          {body && (
            <p
              style={{
                fontSize: px(13),
                lineHeight: 1.6,
                color: 'rgba(60,40,20,0.72)',
                marginTop: px(10),
                textAlign: 'center',
              }}
            >
              {body}
            </p>
          )}

          <div style={{ marginTop: px(16), display: 'flex', justifyContent: 'center' }}>
            <SocialBrewBadge rating={rating} ratingCount={ratingCount} tone="light" scale={scale} />
          </div>
        </div>
      </div>
    </div>
  )
}
